// @flow
import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import withLoading from '../../../components/modules/withLoading/withLoading';
import './matching.scss';
import { Typography } from "src/latest/src/components";
import CATherapistsListContainer from '../../../components/modules/ClinicianAvailabilityTherapistsList/CATherapistsListContainer';
import CAFilterContainer from '../../../components/modules/ClinitianAvailabilityFilter/CAFilterContainer';
import TherapistSearch from './TherapistSearch/TherapistSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftRotate } from '@fortawesome/free-solid-svg-icons';
import MiniCheckBox from 'src/components/modules/MiniCheckBox/MiniCheckBox';
import ApplyFilterContainer from '../Modals/ApplyFilterContainer';
import { useIsMobile } from "src/latest/src/hooks";
import MatchScoreModal from 'src/components/modules/ClinicianAvailabilityTherapistsList/TherapistListCard/MatchScoreModal';
import ContentSorting from './ContentSorting';

type Props = {
    choices?: any,
    therapistsList: Array<Object>,
    dateRequested: Array<string>,
    isLoading: boolean,
    selectedFilters: Object,
    handleOnClickFilterMatches: Function,
    userData: Object,
    toggleIsReadMore: Function,
    isFetching: boolean,
    searchUpdatedFilter: Object,
    setSearchUpdatedFilter: Function,
    loadMoreResult: Funciton,
    offset: number,
    setOffset: Function,
    onBlurSearch: Function,
    onSelected: Function,
    handleDateSliderChange: Function,
    handleCalenderAvailabilityFilter: Function,
    calenderServiceFilters: Array,
    handleScheduleFilterUpdate: Function,
    scheduleFilterObject: any;
    selectedTherapist?: string,
    onPageChange: Function,
    totalPages: Number,
    currentPage: Number,
    clinicianFound: Number,
    selectedUserId: String,
    isFromQuestionnaire: Boolean,
    updateSlot: Function,
    handleOnclick: Function,
    isWithEmptySlot: Boolean,
    setIsWithEmptySlot: Function,
    setIsWithEmptySlot: Function,
    handleCombinedFiltersApply: Function,
    selectedOption:String,
    handleSelectedOption:Function,
    handleLaterSlot:Function,
};

function ClitianAvailabilityScreen({
    choices,
    therapistsList,
    dateRequested,
    selectedFilters,
    userData,
    isFetching,
    searchUpdatedFilter,
    setSearchUpdatedFilter, // check this
    loadMoreResult,
    offset,
    setOffset,
    onSelected,
    handleDateSliderChange,
    handleCalenderAvailabilityFilter,  // check this
    calenderServiceFilters,
    handleScheduleFilterUpdate, // check this
    scheduleFilterObject,
    selectedTherapist,
    onPageChange,
    totalPages,
    currentPage,
    clinicianFound,
    selectedUserId,
    isFromQuestionnaire,
    updateSlot,
    handleOnclick,
    isWithEmptySlot,
    setIsWithEmptySlot,
    handleCombinedFiltersApply,
    selectedOption,
    handleSelectedOption,
    handleLaterSlot,
}: Props): React$Element<any> {
    // eslint-disable-next-line no-unused-vars
    const [isFloating, setIsFloating] = useState(false);
    const floatingTriggerRef = useRef(null);
    const isFromMobile = useIsMobile();
    const showMatchScoreBtn = useSelector((state) => state?.questionnaireData?.initialMetadata?.show_match_score_btn);

    const handleIntersection = (entries) => {
        const [entry] = entries;

        setIsFloating(!entry.isIntersecting);
    };

    useEffect(() => {
        const observer = new IntersectionObserver(handleIntersection, {
            rootMargin: "10px",
            threshold: [1],
        });

        observer.observe(floatingTriggerRef.current);

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div className="matching matching-container">
            <div
                className={`matching__header matching-header_width  ${isFromQuestionnaire ? "mt-0" : ""
                    }`}
                style={{ flexDirection: isFromMobile ? "column" : "row" }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: isFromMobile ? "100%" : "70%", alignItems: 'baseline' }}>
                    <div style={{ width: isFromMobile ? "80%" : "100%", display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        {isFromQuestionnaire ||
                            localStorage.getItem("isFromBookingPage") ? (

                            <Typography
                                className='self-match-header'
                                component="span"
                                variant={isFromMobile ? "size-22" : "size-34"}
                            >
                                Select an Intake Appointment Time
                            </Typography>
                        ) : (
                            <Typography
                                component="span"
                                variant={isFromMobile ? "size-22" : "size-34"}
                            >
                                Clinician Availability
                            </Typography>
                        )}
                        <Typography
                            variant="size-12"
                            weight="semi-bold"
                            color="color-19"
                            className={`d-block ${isFromMobile ? "text-start " : "me-5"
                                } ${isFromMobile && (isFromQuestionnaire ||
                            localStorage.getItem("isFromBookingPage")) ? "ms-4" : ""}`}
                        >
                            {clinicianFound} CLINICIAN FOUND
                        </Typography>
                    </div>
                    <div className='mobile-filter-container d-flex justify-content-center align-items-center'>
                    <div>
                        {isFromMobile && (
                            <ApplyFilterContainer
                                selectedFilters={selectedFilters}
                                searchUpdatedFilter={searchUpdatedFilter}
                                scheduleFilterObject={scheduleFilterObject}
                                selectedTherapist={selectedTherapist}
                                calenderServiceFilters={
                                    calenderServiceFilters
                                }
                                applyFilter={handleCombinedFiltersApply}
                            />
                        )}
                        </div>
                        <div className='toggle-availability-container'>
                    <div className={`filter-wrapper ${selectedOption !== 'MOST' ? 'sorting' : ''}`}>
                        <ContentSorting selectedOption={selectedOption} handleSelect={handleSelectedOption} />
                    </div>
                </div>
                    </div>
                </div>
                <div style={{ position : isFromMobile ? "" : "relative", right : isFromMobile ? "" : "88px",  width: isFromMobile ? "100%" : "auto", marginTop: isFromMobile ? `${isFromQuestionnaire || localStorage.getItem("isFromBookingPage") ? "35px": "16px"}` : "0px" }} ref={floatingTriggerRef}>
                    {isFromQuestionnaire === false ||
                        (isFromQuestionnaire === null && (
                            <TherapistSearch
                                onSelected={onSelected}
                            />
                        ))}
                </div>
               
            </div>

            <div className={`matching__content ${isFromQuestionnaire || localStorage.getItem("isFromBookingPage") ? (!isFetching ? 'matching__content-left' : '') : ''} mt-5`} style={{ display: 'flex' }}>
                {!isFromMobile && (
                    <div style={{ width: "300px", marginRight: '32px' }}>
                        <div
                            className={`calculate-button-container ${isFloating === true ? "floating-matchscore-button-slider" : ""
                                }`}
                        >
                            {showMatchScoreBtn && (
                                <>
                                    <MatchScoreModal />
                                </>
                            )}
                        </div>
                        <CAFilterContainer
                            selectedFilters={selectedFilters}
                            searchUpdatedFilter={searchUpdatedFilter}
                            calenderServiceFilters={calenderServiceFilters}
                            setSearchUpdatedFilter={setSearchUpdatedFilter}
                            handleAvailabilityFilter={
                                handleCalenderAvailabilityFilter
                            }
                            handleScheduleFilterUpdate={
                                handleScheduleFilterUpdate
                            }
                        />
                        {!isFromQuestionnaire && (
                            <div className="mt-4">
                                <MiniCheckBox
                                    isCheckFirst={true}
                                    text={
                                        "Show clinicians with no availability"
                                    }
                                    isActive={isWithEmptySlot}
                                    onClick={() =>
                                        setIsWithEmptySlot(!isWithEmptySlot)
                                    }
                                />
                            </div>
                        )}
                        <div
                            className="mt-5 ms-1 cursor-pointer"
                            onClick={() => {
                                window.location.reload();
                            }}
                        >
                            <Typography
                                variant="size-14"
                                color="color-28"
                                weight="bold"
                            >
                                <FontAwesomeIcon
                                    className="me-2"
                                    icon={faArrowLeftRotate}
                                />{" "}
                                Reset All to Default{" "}
                            </Typography>
                        </div>
                    </div>
                )}
                <div style={{ width: isFromMobile ? "100%" : "925px" }}>
                    {
                        <CATherapistsListContainer
                            choices={choices}
                            isFetching={isFetching}
                            list={therapistsList}
                            dateRequested={dateRequested}
                            userData={userData}
                            loadMoreResult={loadMoreResult}
                            offset={offset}
                            setOffset={setOffset}
                            handleSliderDateChange={handleDateSliderChange}
                            isFloating={isFloating}
                            onPageChange={onPageChange}
                            totalPages={totalPages}
                            currentPage={currentPage}
                            selectedUserId={selectedUserId}
                            updateSlot={updateSlot}
                            handleOnclick={handleOnclick}
                            isFromMobile={isFromMobile}
                            selectedFilters={selectedFilters}
                            handleLaterSlot={handleLaterSlot}
                        />
                    }
                </div>
            </div>
        </div>
    );
}

const ClicianAvailability: any = withLoading < React$Element < Props >> (
    ClitianAvailabilityScreen
);

export default ClicianAvailability;
